export enum SmartSearchType {
  Default = 'default',
  Add = 'add',
}
